import React from "react";
import { steps } from "../data/mock";

export default function Process() {
  return (
    <section className="px-5 py-24 md:px-10 md:py-28">
      <div className="mx-auto max-w-[1180px]">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-[12px] font-semibold tracking-widest-custom uppercase text-[#9c8345]">
            Como funciona
          </span>
          <h2 className="font-serif-display mt-4 text-[38px] leading-[1.1] text-[#0e1a2b] md:text-[54px]">
            Um processo simples, transparente e sem risco financeiro
          </h2>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {steps.map((s) => (
            <div
              key={s.number}
              className="relative rounded-xl border border-[#e2dccb] bg-white p-7 elev-card md:p-8"
            >
              <div className="font-serif-display text-[28px] text-[#b89c60]">{s.number}</div>
              <h3 className="font-serif-display mt-3 text-[24px] text-[#0e1a2b]">
                {s.title}
              </h3>
              <p className="mt-3 text-[14px] leading-relaxed text-[#54657a]">
                {s.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mx-auto mt-10 max-w-3xl rounded-lg border border-[#e2dccb] bg-[#efebda]/60 px-6 py-5 text-center">
          <p className="text-[13px] leading-relaxed text-[#54657a]">
            O tempo de tramitação é uma estimativa baseada na média de processos similares
            e pode variar conforme o caso concreto e o trâmite judicial.
          </p>
        </div>
      </div>
    </section>
  );
}
